import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import { observer } from 'mobx-react';

import QuoteStore from '@/stores/QuoteStore';

// The PartsBadger red and the slate of the portal's headings and text.
const BRAND_RED = '#cc0000';
const HEADING = '#1e293b';
const TEXT = '#455560';

/**
 * Holds the place of the first part while a batch of several parts uploads, so the user can tell
 * the files were taken. It disappears as soon as one part of the batch is added.
 */
const AddingPartsCard = observer(() => {
    if (!QuoteStore.awaitingFirstPart) return null;

    const count = QuoteStore.pendingUploadCount;

    return (
        <div
            aria-busy="true"
            aria-label="Adding parts"
            data-testid="adding-parts-card"
            role="status"
            style={{
                marginBottom: 16,
                padding: '20px 24px',
                borderRadius: 12,
                border: '1px solid #e5e7eb',
                borderLeft: `4px solid ${BRAND_RED}`,
                background: '#fff',
                boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
            }}
        >
            <div className="d-flex align-items-center" style={{ gap: 14, marginBottom: 16 }}>
                <LoadingOutlined spin style={{ color: BRAND_RED, fontSize: 28, flexShrink: 0 }} />
                <div>
                    <div
                        data-testid="adding-parts-title"
                        style={{ color: HEADING, fontSize: 18, fontWeight: 700, lineHeight: 1.3 }}
                    >
                        Adding {count} {count === 1 ? 'part' : 'parts'}…
                    </div>
                    <div style={{ color: TEXT, fontSize: 13, marginTop: 2 }}>
                        Your first part appears here as soon as it is ready.
                    </div>
                </div>
            </div>
            <Skeleton active avatar={{ shape: 'square', size: 56 }} paragraph={{ rows: 3 }} />
        </div>
    );
});

export default AddingPartsCard;
